// import React, { useState } from 'react';
import infoIcon from "../../parm_assets/tree_icons.png";
import "../../component/membership/membership_page_2_section1.css";
import "../../component/membership/membership_page_2_section2.css";
import { Upload, ChevronDown, Image as ImageIcon } from 'lucide-react';
import React, { useState, useRef } from 'react';
import { db, storage } from '../../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { FaEyeSlash } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import ReCAPTCHA from 'react-google-recaptcha';

// const MALAYSIAN_STATES = [
//   "Johor", "Kedah", "Kelantan", "Melaka", "Negeri Sembilan", 
//   "Pahang", "Pulau Pinang", "Perak", "Perlis", "Sabah", 
//   "Sarawak", "Selangor", "Terengganu", 
//   "Wilayah Persekutuan Kuala Lumpur", 
//   "Wilayah Persekutuan Putrajaya", 
//   "Wilayah Persekutuan Labuan"
// ];



const MemberRegistration = () => {

  const navigate = useNavigate();
  const auth = getAuth();

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const initialState = {
    name: '',
    caNo: '',
    icNo: '',
    parmNo: '',
    address: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyAdd:'',
    memberType: '',
    fieldOfWorks: '',
    experienceType: '',
    experiencePhase: ''
    // ... add all other fields
  };

  const [studentIdFile, setStudentIdFile] = useState(null);
  const [passportFile, setPassportFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [formData, setFormData] = useState(initialState);

  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false); // To track if submit was attempted

  const handleCaptchaChange = (token) => {
    // When the user clicks "I'm not a robot", Google returns a secure validation string
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    // If they wait too long without submitting, clear out the stale token
    setCaptchaToken(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow a drop
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    
    const files = e.dataTransfer.files;
    if (files && files[0]) {
      // Reuse your existing logic for file size/type validation
      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        alert("File too large!");
        return;
      }
      setPassportFile(file);
    }
  };

  const formatIC = (value) => {
  // 1. Remove all non-digits
    const cleanValue = value.replace(/\D/g, "");
    
    // 2. Limit to 12 digits
    const limitedValue = cleanValue.slice(0, 12);
    
    // 3. Apply the format: 000000-00-0000
    if (limitedValue.length > 8) {
      return `${limitedValue.slice(0, 6)}-${limitedValue.slice(6, 8)}-${limitedValue.slice(8)}`;
    } else if (limitedValue.length > 6) {
      return `${limitedValue.slice(0, 6)}-${limitedValue.slice(6)}`;
    }
    
    return limitedValue;
  };
    

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);

    // If the user is typing in confirmPassword, check if it matches password
    if (name === 'confirmPassword' || name === 'password') {
      if (updatedData.password === updatedData.confirmPassword) {
        setErrors(prev => ({ ...prev, confirmPassword: false }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    let newErrors = {};

    // --- STEP 1: VALIDATION (Do this first!) ---
    const requiredFields = ['name', 'icNo', 'email', 'password', 'confirmPassword', 'phone', 'address', 'companyAdd', 'memberType', 'fieldOfWorks', 'experienceType', 'experiencePhase'];


    requiredFields.forEach(field => {
      if (!formData[field] || formData[field] === "" || (typeof formData[field] === 'string' && formData[field].includes("Select"))) {
        newErrors[field] = true;
      }
    });

    // 1. Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = true;
      alert("Passwords do not match!");
    }

    // 2. Check for minimum length (Firebase requires at least 6 characters)
    if (formData.password.length < 6) {
      newErrors.password = true;
      alert("Password must be at least 6 characters.");
    }

    if (!passportFile) newErrors['passportFile'] = true;

    if (!passportFile) {
      newErrors['passportFile'] = true;
    }

    // Check IC Length
    const cleanIC = formData.icNo.replace(/(\d{6})(\d{2})(\d{4})/, "$1-$2-$3");
    if (cleanIC.length !== 14) {
      newErrors.cleanIC = true;
      alert("Please enter a valid 12-digit IC Number.");
      return;
    }

    // If there are errors, STOP HERE. Don't upload anything.
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      // window.scrollTo({ top: 0, behavior: 'smooth' });
      return; 
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      // Optional: Alert the user specifically about the file
      if (newErrors.passportFile) {
        alert("Please upload your passport photo.");
      }
      return; 
    }

    // --- STEP 2: FIREBASE START ---
    setLoading(true); // Only start loading after validation passes
    setErrors({});

    if (!captchaToken) {
      alert("Please complete the reCAPTCHA verification step before submitting.");
      return;
    }

    try {

      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        formData.email, 
        formData.password
      );

      const userUID = userCredential.user.uid;

      const docRef = doc(db, "registrations", userUID);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        alert("This IC Number is already registered.");
        setLoading(false);
        return;
      }

      let studentIdUrl = "";
      let passportUrl = "";

      // --- STEP 3: UPLOADS ---
      if (studentIdFile) {
        const idRef = ref(storage, `studentProof/${cleanIC}_studentID_${Date.now()}`);
        const snap = await uploadBytes(idRef, studentIdFile);
        studentIdUrl = await getDownloadURL(snap.ref);
      }

      if (passportFile) {
        const passRef = ref(storage, `passportsPicture/${cleanIC}_passport_${Date.now()}`);
        const snap = await uploadBytes(passRef, passportFile);
        passportUrl = await getDownloadURL(snap.ref);
      }

      const { password, confirmPassword, ...dataToSave } = formData;

      // --- STEP 4: SAVE TO FIRESTORE ---
      await setDoc(doc(db, "registrations", userUID), {
        ...dataToSave,
        uid: userUID,
        icNo: cleanIC,
        password: "",
        studentIdUrl,
        passportUrl,
        joinedDate: new Date(),
        status: "pending_proposer", // The initial state
        proposers: [],
      });

      alert("Account registered successfully! Please log in and complete the verification process");
      navigate('/login-parm');

      setFormData(initialState);      // Resets all text fields
      setStudentIdFile(null);         // Resets Student ID file
      setPassportFile(null);          // Resets Passport file
      setErrors({});                  // Clears any leftover red borders
      setSubmitted(false);            // Resets the submission tracker

      document.getElementById("passport-upload-input").value = "";
      if (document.getElementById("studentIdUpload")) {
        document.getElementById("studentIdUpload").value = "";
      }

    } catch (error) {
      console.error("Error saving to Firebase:", error);
      alert("Error: " + error.message);

      recaptchaRef.current.reset();
      setCaptchaToken(null);
    } finally {
      setLoading(false);
    }
  };

  const registrations = [
    {
      title: "Professional Members",
      eligibility: "Certified arborists by the International Society of Arboriculture.",
      regFee: "RM 100.00",
      annualFee: "RM 100.00",
      notes: "Eligible to vote, propose, and support motions in general meetings."
    },
    {
      title: "Ordinary Members",
      eligibility: "Interested individuals who have attended the Arborist Certification Course.",
      regFee: "RM 100.00",
      annualFee: "RM 50.00",
      notes: "Eligible to vote, propose, and support motions in general meetings."
    },
    {
      title: "Corporate Members",
      eligibility: "Open to commercial firms and organizations with three representatives supporting PArM’s goals.",
      regFee: "RM 2000.00",
      annualFee: "RM 2000.00",
      notes: "Only one-third of representatives are eligible to vote in meetings."
    },
    {
      title: "Veteran Members",
      eligibility: "Retirees (60 years old) from government or private service. Must have been Professional or Ordinary members for 5 years with good standing.",
      regFee: "RM 25.00",
      annualFee: "RM 25.00",
      notes: "Eligible to vote, propose, and support motions in general meetings."
    },
    {
      title: "Lifetime Members",
      eligibility: "Ordinary members who pay a one-time fee. Must have been Professional or Ordinary members for 5 years with good standing.",
      regFee: "RM 1000.00 (One-Time)",
      annualFee: "Not applicable.",
      notes: "Eligible to vote, propose, and support motions in general meetings."
    },
    {
      title: "Student Members",
      eligibility: "Full-time students in Arboriculture, urban forestry, landscape, botany, or agriculture courses. Courses should last at least 2 years at a recognized institution.",
      regFee: "RM 10.00 (One-Time)",
      annualFee: "RM 25.00",
      notes: "Not eligible to vote or propose motions in general meetings."
    }
  ];

  return (
    <div className="page-container">
    <section className="member-registration-section">
      <div className="member-registration-container">
        <header className="member-registration-header">
          <p className="member-purpose-badge"> <img src={infoIcon} alt="icon" className="tree-icon" /> REGISTRATION FORM</p>
          <h2 className="member-reg-title">PArM’s Registration</h2>
        </header>

        <div className="member-reg-grid">
          {registrations.map((item, index) => (
            <div key={index} className="member-reg-card">
              <h3 className="member-reg-card-title">{item.title}</h3>
              
              <div className="member-reg-content-block">
                <h4>Eligibility:</h4>
                <p>- {item.eligibility}</p>
              </div>

              <div className="member-reg-content-block">
                <h4>Fee:</h4>
                <p>Registration: {item.regFee}</p>
                <p>Annual Fee: {item.annualFee}</p>
              </div>

              <div className="member-reg-content-block">
                <h4>Notes:</h4>
                <p>- {item.notes}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>


    <section className="member-registration-form-section">
    <div className="registration-wrapper">
      <header className="form-header">
        {/* <span className="badge">📑 REGISTRATION FORM</span> */}
        <h1>PArM’s Registration</h1>
      </header>

      <form onSubmit={handleSubmit} className="main-form">
        <div className="form-grid">
          {/* Personal Info Section */}
          <div className="input-group">
            <label>Name (As stated in Identity Card)</label>
            <input
            type="text" 
            name="name" // Important: matches state key
            placeholder="Name"
            // style={{ textTransform: 'uppercase' }} 
            value={formData.name}
            className={errors.name ? 'error-border' : ''}
            onChange={(e) => {
              handleChange(e);
              if (errors.name) setErrors({ ...errors, name: false });
            }}
            // onChange={handleChange}
            required
            />
            {errors.name && <span className="error-text">Full name is required</span>}
          </div>
          <div className="input-group">
            <label>CA No. (If Applicable)</label>
            <input 
              type="text" 
              name="caNo" // Important: matches state key
              placeholder="CA No." 
              value={formData.caNo}
              onChange={handleChange}
              />
          </div>
          <div className="input-group">
            <label>IC No.</label>
            <input 
              type="text"
              inputMode="numeric"
              name="icNo" 
              placeholder="000000-00-0000" 
              value={formData.icNo}
              className={errors.icNo ? 'error-border' : ''}
              onChange={(e) => {
                // Format the value before passing it to state
                const formattedIC = formatIC(e.target.value);
                
                // Manual state update to include the hyphens
                setFormData({ ...formData, icNo: formattedIC });

                // Clear error if typing
                if (errors.icNo) setErrors({ ...errors, icNo: false });
              }}
              required
              maxLength={14} // Important: 12 digits + 2 hyphens = 14
            />
             {errors.icNo && <span className="error-text">IC No. is required</span>}
          </div>
          <div className="input-group">
            <label>PARM No. (If Applicable)</label>
            <input
              type="text" 
              name="parmNo" // Important: matches state key
              placeholder="PArM No" 
              value={formData.parmNo}
              onChange={handleChange}
            />
          </div>
          
          <div className="input-group full-width">
            <label>House Address</label>
            <textarea
              name="address" // Important: matches state key
              placeholder="Address" 
              value={formData.address}
              className={errors.address ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.address) setErrors({ ...errors, address: false });
              }}
              required
              rows="3" 
            />
            {errors.address && <span className="error-text">Address is required</span>}
          </div>

          {/* <div className="input-group">
            <label className="center-label">Postcode</label>
            <input
              type="text" 
              inputMode="numeric"
              name="postcode" // Important: matches state key
              placeholder="Postcode" 
              value={formData.postcode}
              className={errors.postcode ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.postcode) setErrors({ ...errors, postcode: false });
              }}
              required 
              maxLength={5}
            />
            {errors.postcode && <span className="error-text">Postcode is required</span>}
          </div>

          <div className="input-group">
            <label className="center-label">State</label>
            <div className={`select-container ${errors.state ? 'error-border' : ''}`}>
              <select
                name="state" 
                value={formData.state} 
                onChange={(e) => {
                  handleChange(e);
                  // Clear error as soon as user selects something
                  if(errors.state) setErrors({...errors, state: false});
                }}
                >
                <option value="">Select State</option>
                {MALAYSIAN_STATES.map((state) => (
                  <option key={state} value={state}>{state}</option>
                ))}
                </select>
              <div className="select-icon"><ChevronDown size={18} /></div>
            </div>
            {errors.state && <span className="error-text">Please select a state</span>}
          </div> */}

          {/* Contact Section */}
          {/* <div className="input-group">
            <label>Date of birth</label>
            <input 
              type="date"
              name="dob" // Important: matches state key
              value={formData.dob}
              className={errors.dob ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.dob) setErrors({ ...errors, dob: false });
              }}
              required
            />
            {errors.dob && <span className="error-text">Date of birth is required</span>}
          </div> */}
          <div className="input-group">
            <label>Phone Number</label>
            <input
            type="text" 
              inputMode="numeric"
              name="phone" // Important: matches state key
              placeholder="012-3456789" 
              value={formData.phone}
              className={errors.phone ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.phone) setErrors({ ...errors, phone: false });
              }}
              required
            />
            {errors.phone && <span className="error-text">Phone No. is required</span>}
          </div>
          {/* <div className="input-group">
            <label>Telephone Number</label>
            <input 
              type="text" 
              inputMode="numeric"
              name="housePhoneNo" // Important: matches state key
              placeholder="House Phone No." 
              value={formData.housePhoneNo}
              onChange={handleChange}
             />
          </div> */}
          <div className="input-group">
            <label>Email (Most Frequent use)</label>
            <input 
              type="email"
              name="email" // Important: matches state key
              placeholder="Email" 
              value={formData.email}
              className={errors.email ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.email) setErrors({ ...errors, email: false });
              }}
              required
            />
            {errors.email && <span className="error-text">Email is required</span>}
          </div>

          {/* Password Field */}
            <div className="input-group">
              <label>Password</label>
              <div className="password-wrapper" style={{ position: 'relative' }}>
                <input 
                  type={showPassword ? "text" : "password"} 
                  name="password"
                  className={errors.password ? 'error-border' : ''}
                  value={formData.password}
                  onChange={handleChange}
                  style={{ width: '100%', paddingRight: '40px' }}
                />
                <button 
                  type="button"
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                >
                  {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                </button>
              </div>
            </div>

            {/* Confirm Password Field */}
            <div className="input-group">
              <label>Confirm Password</label>
              <div className="password-wrapper" style={{ position: 'relative' }}>
                <input 
                  type={showPassword ? "text" : "password"} 
                  name="confirmPassword"
                  className={errors.confirmPassword ? 'error-border' : ''}
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  style={{ width: '100%', paddingRight: '40px' }}
                />
              </div>
              {errors.confirmPassword && (
                <span className="error-text">Passwords do not match</span>
              )}
            </div>

          {/* Company Section */}
          {/* <div className="input-group full-width">
            <label>Company's Name</label>
            <input 
              type="text"
              name="companyName" // Important: matches state key
              placeholder="Company's Name" 
              value={formData.companyName}
              className={errors.companyName ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.companyName) setErrors({ ...errors, companyName: false });
              }}
              required
            />
            {errors.companyName && <span className="error-text">Company Name is required</span>}
          </div> */}
          <div className="input-group full-width">
            <label>Company's Name and Address</label>
            <textarea
              name="companyAdd" // Important: matches state key
              placeholder="Company's Name and Address"
              value={formData.companyAdd}
              className={errors.companyAdd ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.companyAdd) setErrors({ ...errors, companyAdd: false });
              }}
              required
              rows="3" 
            />
            {errors.companyAdd && <span className="error-text">Company's Name and Address is required</span>}
          </div>

          {/* <div className="input-group">
            <label>Company's Postcode</label>
            <input
              type="text" 
              inputMode="numeric"
              name="companyPostcode" // Important: matches state key
              placeholder="Company's Postcode" 
              value={formData.companyPostcode}
              className={errors.companyPostcode ? 'error-border' : ''}
              onChange={(e) => {
                handleChange(e);
                // Remove red border immediately when user starts typing
                if (errors.companyPostcode) setErrors({ ...errors, companyPostcode: false });
              }}
              required
              maxLength={5}
            />
            {errors.companyPostcode && <span className="error-text">Company's Postcode is required</span>}
          </div> */}
          {/* <div className="input-group">
            <label>State</label>
            <div className={`select-container ${errors.companyState ? 'error-border' : ''}`}>
              <select
                name="companyState" 
                value={formData.companyState} 
                onChange={(e) => {
                handleChange(e);
                // Clear error as soon as user selects something
                if(errors.companyState) setErrors({...errors, companyState: false});
              }}
                >
                <option value="">Select State</option>
                {MALAYSIAN_STATES.map((state) => (
                  <option key={state} value={state}>{state}</option>
                ))}
                </select>
              <div className="select-icon"><ChevronDown size={18} /></div>
            </div>
            {errors.companyState && <span className="error-text">Please select a company's state</span>}
          </div> */}
          {/* <div className="input-group">
            <label>Telephone Number</label>
            <input
              type="text" 
              inputMode="numeric"
              name="companyTelNo" // Important: matches state key
              placeholder="Company's Phone No." 
              value={formData.companyTelNo}
              onChange={handleChange}
              />
          </div> */}
          {/* <div className="input-group">
            <label>Email (Most Frequent use)</label>
            <input type="email" />
          </div> */}
        </div>

       {/* Professional Details Grid */}
        <div className="professional-grid">
          <div className="input-group">
            <label>Type of Members</label>
            <div className={`select-container ${errors.memberType ? 'error-border' : ''}`}>
              <select 
                name="memberType" 
                value={formData.memberType} 
                onChange={(e) => {
                  handleChange(e);
                  // Clear error as soon as user selects something
                  if(errors.memberType) setErrors({...errors, memberType: false});
                }}
              >
                <option value="">Select Type of Members</option>
                <option value="Professional Members">Professional Members</option>
                <option value="Ordinary Members">Ordinary Members</option>
                <option value="Corporate Members">Corporate Members</option>
                <option value="Veteran Members">Veteran Members</option>
                <option value="Lifetime Members">Lifetime Members</option>
                <option value="Student Members">Student Members</option>
              </select>
              <div className="select-icon"><ChevronDown size={18} /></div>
            </div>
            {errors.memberType && <span className="error-text">Please select a member type</span>}
          </div>

          {/* ✅ CONDITIONAL RENDERING START */}
          {formData.memberType === "Student Members" && (
            <div className="upload-container">
              <label>Upload Student ID (for Student member only)</label>
              <div className="upload-box">
                <Upload className="upload-icon-main" />
                <div className="upload-text">
                  <p>Select a file here</p>
                  <span>JPG, PNG or PDF, file size no more than 2MB</span>
                </div>
                {/* Make sure this hidden file input is triggered by the button */}
                <input 
                  type="file" 
                  style={{ display: 'none' }} 
                  id="studentIdUpload"
                  onChange={(e) => setStudentIdFile(e.target.files[0])}
                />
                <button 
                  type="button" 
                  className="select-file-btn"
                  onClick={() => document.getElementById('studentIdUpload').click()}
                >
                  SELECT FILE
                </button>
              </div>
              {/* Visual confirmation of file selection */}
              {studentIdFile && <p className="file-name">Selected: {studentIdFile.name}</p>}
            </div>
          )}

          <div className="input-group">
            <label>Applicant Field of Works</label>
            <div className={`select-container ${errors.fieldOfWorks ? 'error-border' : ''}`}>
              <select
                name="fieldOfWorks" 
                value={formData.fieldOfWorks} 
                onChange={(e) => {
                  handleChange(e);
                  // Clear error as soon as user selects something
                  if(errors.fieldOfWorks) setErrors({...errors, fieldOfWorks: false});
                }}
                >
                <option value="" >Select Field of Works</option>
                <option value="Komersial / Kediaman" >Komersial / Kediaman</option>
                <option value="Perundingan" >Perundingan</option>
                <option value="Perundingan" >Pendidikan</option>
                <option value="Lanjutan">Lanjutan</option>
                <option value="Perhutanan">Perhutanan</option>
                <option value="Penyelidikan">Penyelidikan</option>
                <option value="Padang Golf">Padang Golf </option>
                <option value="Landskap">Landskap</option>
                <option value="Perbandaran">Perbandaran</option>
                <option value="Kerja Awam">Kerja Awam</option>
                <option value="Saluran Paip">Saluran Paip</option>
                <option value="Latihan">Latihan</option>
                <option value="Utiliti">Utiliti</option>
                <option value="Pengurusan Pokok">Pengurusan Pokok</option>
                <option value="Pembekal">Pembekal</option>
                <option value="Lain-lain">Lain-lain</option>

                
                </select>
              <div className="select-icon"><ChevronDown size={18} /></div>
            </div>
            {errors.fieldOfWorks && <span className="error-text">Please select field of work</span>}
          </div>
          <div className="input-group">
            <label>Related to Applicant Experiences</label>
            <div className={`select-container ${errors.experienceType ? 'error-border' : ''}`}>
              <select
                name="experienceType" 
                value={formData.experienceType} 
                onChange={(e) => {
                  handleChange(e);
                  // Clear error as soon as user selects something
                  if(errors.experienceType) setErrors({...errors, experienceType: false});
                }}
                >
                <option value="" >Select Applicant Experiences</option>
                <option value="Perunding" >Perunding</option>
                <option value="Ketua Krew" >Ketua Krew</option>
                <option value="Pengarah" >Pengarah</option>
                <option value="Pekebun" >Pekebun</option>
                <option value="Landskap Arkitek " >Landskap Arkitek</option>
                <option value="Pengurus" >Pengurus</option>
                <option value="Pemasaran/ jualan" >Pemasaran/ jualan</option>
                <option value="Pemilik" >Pemilik</option>
                <option value="Perancang" >Perancang</option>
                <option value="Presiden/ Pegawai " >Presiden/ Pegawai </option>
                <option value="Arborist Bertauliah" >Arborist Bertauliah</option>
                <option value="Pengajar" >Pengajar</option>
                <option value="Pelajar">Pelajar</option>
                <option value="Jurulatih">Jurulatih</option>
                <option value="Pekerja pokok / pemanjat pokok">Pekerja pokok / pemanjat pokok</option>
                <option value="Lain-lain">Lain-lain</option>
                </select>
              <div className="select-icon"><ChevronDown size={18} /></div>
            </div>
            {errors.experienceType && <span className="error-text">Please select experience type</span>}
          </div>
          <div className="input-group">
            <label>Phase of Arboriculture experience</label>
            <div className={`select-container ${errors.experiencePhase ? 'error-border' : ''}`}>
              <select
                 name="experiencePhase" 
                value={formData.experiencePhase} 
                onChange={(e) => {
                  handleChange(e);
                  // Clear error as soon as user selects something
                  if(errors.experiencePhase) setErrors({...errors, experiencePhase: false});
                }}
                >
                <option value="" >Select Phase of Arboriculture experience</option>
                <option value="Kurang daripada 5 tahun" >Kurang daripada 5 tahun</option>
                <option value="Lebih daripada 5 tahun" >Lebih daripada 5 tahun</option>
                <option value="Lebih daripada 15 tahun">Lebih daripada 15 tahun</option>
               
                </select>
              <div className="select-icon"><ChevronDown size={18} /></div>
            </div>
            {errors.experiencePhase && <span className="error-text">Please select experience phase</span>}
          </div>
        </div>

        <div className="footer-actions">
          <label htmlFor="passport-upload-input" style={{ cursor: 'pointer' }}>
           <div 
            className={`passport-upload ${isDragging ? "dragging" : ""} ${errors.passportFile ? "error-border" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={errors.passportFile ? { border: '2px solid #ef4444', backgroundColor: '#fef2f2' } : {}}
          >
            <div className="icon-circle">
              {/* If there's an error and no file, maybe turn the icon red */}
              <ImageIcon size={30} color={passportFile ? "#22c55e" : (errors.passportFile ? "#ef4444" : "#666")} />
            </div>
            <div className="upload-info">
              <p style={{ color: errors.passportFile ? "#ef4444" : "inherit" }}>
                {passportFile ? `✅ ${passportFile.name}` : "Select a file or drag and drop here"}
              </p>
              <span>Passport size image, JPG, PNG, file size no more than 5MB</span>
            </div>
          </div>

          {/* The Error Message */}
            {errors.passportFile && (
              <span className="error-text" style={{ color: '#ef4444', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                ⚠️ Passport photo is required.
              </span>
            )}

            {/* The actual hidden input that talks to your handleSubmit */}
            <input 
              id="passport-upload-input"
              type="file" 
              accept="image/jpeg, image/png" 
              onChange={(e) => {
                const file = e.target.files[0];
                setPassportFile(file);
                // Clear error as soon as a file is picked
                if (file) setErrors(prev => ({ ...prev, passportFile: false }));
              }}
              style={{ display: 'none' }} 
              
            />
          </label>

          {/* 🟢 THE RECAPTCHA COMPONENT */}
          <div className="captcha-wrapper" style={{ margin: '20px 0' }}>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6Le1lkQtAAAAAIfNQMmyRcRWl5tsid5zLtS3KMi9" // Change this to your real public sitekey
              onChange={handleCaptchaChange}
              onExpired={handleCaptchaExpired}
            />
          </div>

          <a href="/membership-proposer-parm">
          <button 
          type="submit" 
          className="next-btn"
          disabled={loading}
          >
            Submit</button>
          </a>
        </div>
      </form>
    </div>
    </section>
    
    </div>
  );
};

export default MemberRegistration;